import { useMediaQuery } from '@mildang/mui';
import { Theme } from '@mildang/mui';
import Button from '@mildang/design-system-legacy/esm/components/molecules/Button';
import ArrowBackIcon from '@mildang/icons/react/arrow-left';
import useRouter from '@ui/hooks/useCustomRouter';
import ErrorTemplate from '@mildang/design-system-legacy/esm/components/molecules/ErrorTemplate';
import { useLingui } from '@lingui/react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { FallbackPage, ResponsiveButton } from '@mildang/design-system/FallbackPage';
import ChevronLeftIcon from '@mildang/icons/react/chevron-left';
import { useFallbackPageEnabled } from '../FallbackPageContext';

export interface NotFoundScreenProps {
  onClickBack?: () => void;
  className?: string;
  title?: string;
  description?: string;
  actionLabel?: string;
}

function NotFoundErrorScreen(props: NotFoundScreenProps) {
  const { i18n } = useLingui();
  const {
    className,
    onClickBack,
    title = t(i18n)`페이지를 찾을 수 없습니다.`,
    description = t(
      i18n,
    )`주소가 잘못되었거나, 더 이상 제공되지 않는 페이지입니다.\n 주소를 다시 한번 확인해주세요.`,
    actionLabel,
  } = props;

  const router = useRouter();

  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));

  const defaultClick = () => router.back();

  const fallbackPageEnabled = useFallbackPageEnabled();
  if (fallbackPageEnabled) {
    return (
      <FallbackPage
        type="notFound"
        className={className}
        title={props.title}
        description={props.description}
        onBack={onClickBack ?? defaultClick}
      >
        {props.actionLabel ? (
          <ResponsiveButton
            variant="primary"
            startIcon={<ChevronLeftIcon />}
            onClick={onClickBack ?? defaultClick}
          >
            {props.actionLabel}
          </ResponsiveButton>
        ) : undefined}
      </FallbackPage>
    );
  }

  return (
    <ErrorTemplate
      className={className}
      title={title}
      description={description}
      action={
        <Button
          startIcon={<ArrowBackIcon />}
          size={isMobile ? 'large' : 'xLarge'}
          variant="contained"
          onClick={onClickBack ?? defaultClick}
        >
          {actionLabel ?? <Trans>이전 페이지로 돌아가기</Trans>}
        </Button>
      }
    />
  );
}

export default NotFoundErrorScreen;
